import { render, staticRenderFns } from "./CToaster.vue?vue&type=template&id=8a579e0e"
import script from "./CToaster.vue?vue&type=script&lang=js"
export * from "./CToaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports